import classNames from 'classnames';
import NegativeMessage from '../../../../../assets/input/negative-information.png';
import { InputField } from '../../../UI/Input/InputField';

const AchDataFields = ({
  achRoutingNumber,
  accountNumber,
  accountType,
  accountNumberValidationMessage,
  achRoutingNumberValidationMessage,
  activeTab,
  showModify,
  handleAchRoutingNumberFn,
  handleAccountNumberFn,
  handleAccountTypeFn,
}: {
  achRoutingNumber?: string;
  accountNumber?: string;
  accountType?: string;
  accountNumberValidationMessage: string | null;
  achRoutingNumberValidationMessage: string | null;
  activeTab: string;
  showModify: boolean;
  handleAchRoutingNumberFn: (event: any) => void;
  handleAccountNumberFn: (event: any) => void;
  handleAccountTypeFn: (event: any) => void;
}) => {
  const checkedRadioButtonClasses =
    'checked:border-transparent checked:focus:ring-accent checked:focus:bg-accent active:bg-accent hover:bg-accent checked:hover:bg-accent checked:focus:ring-1';
  return (
    <div>
      <InputField
        label="ACH routing number"
        id="identifier"
        forId="identifier"
        type="text"
        value={achRoutingNumber}
        className=" mb-3"
        onChange={handleAchRoutingNumberFn}
        readOnly={!showModify}
      />
      {achRoutingNumberValidationMessage && (
        <div className="-mt-1..5 mb-1">
          <div className="flex items-center">
            <img src={NegativeMessage} alt="" className="w-auto h-auto max-w-6 max-h-6" />
            <span className="font-Sweet text-Caption1inline-block align-baseline text-xs ml-2">{achRoutingNumberValidationMessage}</span>
          </div>
        </div>
      )}
      <InputField
        label="Account number"
        id="account number"
        forId="account number"
        type="text"
        value={accountNumber}
        className="mb-3"
        onChange={handleAccountNumberFn}
        readOnly={!showModify}
      />
      {accountNumberValidationMessage && (
        <div className="-mt-1..5">
          <div className="flex items-center">
            <img src={NegativeMessage} alt="" className="w-auto h-auto max-w-6 max-h-6" />
            <span
              dangerouslySetInnerHTML={{ __html: `<p>${accountNumberValidationMessage}</p>` }}
              className="font-Sweet text-Caption1inline-block align-baseline text-xs ml-2"></span>
          </div>
        </div>
      )}
      <p className="text-primary text-[16px] mt-4 mb-4">Account type</p>
      <div className="flex gap-3 ">
        <div>
          <input
            type="radio"
            value={'checking'}
            name="accountType"
            id="checking"
            checked={accountType === 'checking'}
            onChange={handleAccountTypeFn}
            className={classNames('checked:bg-accent', checkedRadioButtonClasses, {
              'checked:bg-accent': accountType === 'checking',
            })}
            readOnly={!showModify}
          />
          <label htmlFor="0" className="ml-1.5">
            Checking
          </label>
        </div>
        <div>
          <input
            type="radio"
            value={'savings'}
            name="accountType"
            id="savings"
            checked={accountType === 'savings'}
            onChange={handleAccountTypeFn}
            className={classNames('checked:bg-accent', checkedRadioButtonClasses, {
              'checked:bg-accent': accountType === 'savings',
            })}
            readOnly={!showModify}
          />
          <label htmlFor="5" className="ml-1.5">
            Savings
          </label>
        </div>
      </div>
    </div>
  );
};

export default AchDataFields;
